import { getInjection } from '@/di/inversify.config';
import { ActivityDivisionInfoData } from '@/entities/DivisionInfoData';
import { Result } from '@/entities/Result';

export const getPlayerActivityUseCase = async (
	organizationUuid: string,
	teamLeagueUuid: string,
	seasonUuid: string
): Promise<Result<ActivityDivisionInfoData[]>> => {
	const teamLeagueeRepository = getInjection('ITeamLeagueRepository');
	return teamLeagueeRepository.getPlayerActivity(organizationUuid, teamLeagueUuid, seasonUuid);
};
